import { Typography, List, Card, ListItem } from '@material-tailwind/react';
import AddButton from '../Buttons/AddButton';
import { useState } from 'react';
import { AddModalCatLn } from '../Modal/AddModalCatLn';

const Listar = ({ array, title, url, news }) => {
  const [modal, setModal] = useState(false);
  const handleModel = () => {
    setModal(!modal);
  };
  return (
    <div className="w-full sm:min-w-52 sm:w-auto  flex-1 bg-transparent dark:bg-darkColorBox rounded-xl border  border-darkColorBorder shadow-darkShadow px-4">
      {title && (
        <Typography
          variant="h5"
          className="dark:text-darkText dark:italic  md:mt-0 text-start 
            border-b border-darkColorHr mt-2 p-3 "
        >
          {title}
          {title && <AddButton handleModel={handleModel} />}
        </Typography>
      )}
      <Card className="overflow-hidden bg-transparent shadow-none">
        <List className="text-black dark:text-white p-2">
          {array?.length > 0 &&
            array.map(({ nome }) => (
              <>
                <ListItem
                  ripple={false}
                  className="uppercase p-1 bg-transparent dark:bg-transparent  rounded-sm px-2 hover:text-yellow-200 "
                  key={nome}
                >
                  - {nome}
                </ListItem>
              </>
            ))}
          {array.length === 0 && (
            <ListItem ripple={false} className="capitalize p-1 text-red-900 font-bold">
              Nenhum subcategoria
            </ListItem>
          )}
        </List>
      </Card>
      <AddModalCatLn
        modal={modal}
        handleModal={handleModel}
        url={url}
        title={`Cadastrar ${title}`}
        news={news}
      />
    </div>
  );
};

export default Listar;
